import React from "react"
import { Link as GatsbyLink } from "gatsby"
import { createLink } from "../utils"
import arrow from "../images/chevron.svg"
import styles from "./Link.module.scss"

const Link = ({
  href,
  className,
  title,
  children,
  arrowIcon = false,
  CustomIcon = null,
}) => {
  const Content = React.useMemo(() => {
    return (
      <>
        {title ?? children}
        {arrowIcon ? (
          <img
            src={arrow}
            alt=""
            className="ml-3"
            width={14}
            height={16}
            style={{ transform: "translateY(-1px)" }}
          />
        ) : null}
        {CustomIcon}
      </>
    )
  }, [children, title, arrowIcon, CustomIcon])

  const link = createLink(href)

  if (link.startsWith("http")) {
    return (
      <a
        href={link}
        className={styles.linkDefaults + `${className ? ` ${className}` : ""}`}
        target="_blank"
        rel="noopener noreferrer"
      >
        {Content}
      </a>
    )
  }

  return (
    <GatsbyLink
      to={link}
      className={styles.linkDefaults + `${className ? ` ${className}` : ""}`}
    >
      {Content}
    </GatsbyLink>
  )
}

export { Link }
